<template>
  <div>
    <v-skeleton-loader
      v-for="n in 3"
      :key="n"
      class="uploads-page-skeleton-loader mb-4"
      elevation="2"
      type="list-item-avatar"
      height="64"
    />
  </div>
</template>

<script>
export default {
  name: 'UploadsPageSkeletonLoader',
};
</script>

<style lang="scss">
.uploads-page-skeleton-loader .v-skeleton-loader__list-item-avatar {
  height: 64px;
}
</style>
